import AssignPercentagesError from './AssignPercentagesError';
class BeneficiaryNotFound extends AssignPercentagesError {
    constructor(options) {
        super('The beneficiary was not found', options);
    }
}
export default BeneficiaryNotFound;
